import { Component, OnInit, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-remove-job',
  templateUrl: './remove-job.component.html',
  styleUrls: ['./remove-job.component.scss']
})
export class RemoveJobComponent implements OnInit {

  unassignEmployee: boolean = false;
  constructor(
    public dialogRef: MatDialogRef<RemoveJobComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
  ) { }

  removeJob(): void {
    this.dialogRef.close({
      users: this.data?.data?.assigned_to,
      unassign: this.unassignEmployee
    })
  }

  ngOnInit(): void {
  }

}
